import { t, Trans } from "@lingui/macro";
import Button from "components/Button/Button";
import Checkbox from "components/Checkbox/Checkbox";
import React from "react";
import { useLocalStorage } from "react-use";
import { TipIcon } from "components/TipIcon";
import ModalWithPortal from "components/Modal/ModalWithPortal";

type Props = {
  isVisible: boolean;
  setIsVisible: (value: boolean) => void;
};

export default function BuyPlpSuccessModal(props: Props) {
  const [dontShowAgain, setDontShowAgain] = useLocalStorage("buy-plp-success-dont-show-again", false);
  const [dontShowAgainCheckbox, setDontShowAgainCheckbox] = React.useState(false);

  const isVisible = React.useMemo(() => {
    if (dontShowAgain === true) {
      return false;
    }
    return props.isVisible;
  }, [props.isVisible, dontShowAgain]);

  const setIsVisible = (value: boolean) => {
    props.setIsVisible(value);

    if (!value && dontShowAgainCheckbox) {
      setDontShowAgain(true);
    }
  };

  return (
    <ModalWithPortal
      isVisible={isVisible}
      setIsVisible={setIsVisible}
      label={t`PLP Bought Successfully`}
      className="tailwind Connecting-wallet-modal"
    >
      <div className="w-full rounded-sm border p-6 flex gap-4">
        <TipIcon className="shrink-0 mt-2" />

        <p className="text-[1.4rem] leading-[2.4rem] text-inactive">
          <Trans>
            Your purchased PLP tokens are now in the staking pool to earn 50% of the trading fees generated by the
            Palmswap Exchange, additional you earn high APR during the Event in PALM. If the PLP tokens are sold before
            the PALM Rewards are fully unlocked, the locked rewards in the respective tier will fully expire. To unstake
            PLP it is enough to sell them.
          </Trans>
        </p>
      </div>

      <Checkbox className="mt-10" isChecked={dontShowAgainCheckbox} setIsChecked={setDontShowAgainCheckbox}>
        <Trans>Don't show this message again</Trans>
      </Checkbox>

      <Button variant="primary-action" size="lg" className="w-full mt-6" onClick={() => setIsVisible(false)}>
        <Trans>I understand</Trans>
      </Button>
    </ModalWithPortal>
  );
}
